'use client';

import { ChakraProvider as ChakraProviderBase } from '@chakra-ui/react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { LuCircleCheck, LuCircleX, LuInfo } from 'react-icons/lu';
import { ToastContainer } from 'react-toastify';

import useHeaderHeightVar from '@/hooks/useHeaderHeightVar';
import { system } from '@/theme/system';

const ChakraProvider = ({ children }: { children: React.ReactNode }) => {
  useHeaderHeightVar();

  return (
    <ChakraProviderBase value={system}>
      <NextThemesProvider attribute="class" enableSystem={true} defaultTheme="light">
        {children}
        <ToastContainer
          icon={({ type }) => {
            switch (type) {
              case 'info':
                return <LuInfo className="stroke-indigo-400" size={20}/>;
              case 'error':
                return <LuCircleX className="stroke-red-500" size={20}/>;
              case 'success':
                return <LuCircleCheck className="stroke-green-500" size={20}/>;
              case 'warning':
                return <LuCircleX className="stroke-yellow-500" size={20}/>;
              default:
                return null;
            }
          }}
        />
      </NextThemesProvider>
    </ChakraProviderBase>
  );
};

export default ChakraProvider;
